import { render, staticRenderFns } from "./CharlaInformativa.vue?vue&type=template&id=6ba56cff&"
import script from "./CharlaInformativa.vue?vue&type=script&lang=js&"
export * from "./CharlaInformativa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports